/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { ArrowRightIcon } from 'modules/icons/ArrowRight';

import * as S from './Links.style';
import * as T from './Links.types';

export const Links: React.FC<T.LinksCollection> = ({ items }) => {
  return (
    <>
      <S.Links className="section">
        <S.Container>
          <h3>Como usar o Direct no meu negócio?</h3>
          <div className="content">
            {items.map((item, index) => {
              return (
                <S.Link href={`#recurso-${index}`} key={item.title}>
                  {item.title}
                  <ArrowRightIcon />
                </S.Link>
              );
            })}
          </div>
        </S.Container>
      </S.Links>
    </>
  );
};
